export * from './post-ort-kategorie.service';
export * from './post-ort-kategorie.service.module';